import { render } from "./KeywordBudget.vue?vue&type=template&id=43ccf45f&scoped=true"
import script from "./KeywordBudget.vue?vue&type=script&lang=js"
export * from "./KeywordBudget.vue?vue&type=script&lang=js"

import "./KeywordBudget.vue?vue&type=style&index=0&id=43ccf45f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43ccf45f"]])

export default __exports__